import { getSpacing } from "@volt_developers/foundations";

export const NAVBAR_HEIGHT = 69;
export const PAGE_HEIGHT = `calc(100vh - ${NAVBAR_HEIGHT}px)`;
export const PAGE_WRAPPER_PADDING = getSpacing(8);
